/* eslint-disable react/button-has-type */
import React from 'react';
import { useNavigate } from 'react-router-dom';

import Heading from 'Components/Heading/Heading';
import Summary from 'Components/Summary/Summary';
import Bussinessplan from '../../Assets/elvotaimages/Bussinessplan.png';
import Powerd from '../../Assets/elvotaimages/Powerd.png';
import Arrowimg from '../../Assets/elvotaimages/Arrowimg.png';

export default function Additional() {
  const navigate = useNavigate();
  const summaryContent1 = [
    'Our precise forecasting and optimization techniques ensure that every charge and discharge decision maximizes profitability and efficiency, setting us apart in the energy storage market.',
  ];
  const summaryContent2 = [
    'Our team’s expertise in AI and Deep Learning, along with our close relation with renewable energy developers worldwide, enables us to use state-of-the-art technology for optimizing energy storage and collaborate closely with developers to implement effective solutions.',
  ];
  return (
    <div>
      <div className=" bg-white ">
        <div className="main-container">
          <div className="grid grid-cols-12 sm:gap-[42px] items-center">
            <div className="col-span-12 lg:col-span-4 relative">
              <div className="flex items-center w-[300px] sm:w-[340px] mx-auto lg:mx-0 lg:w-full">
                <div className="flex flex-col w-[300px] sm:w-[340px] mx-auto lg:mx-0 lg:w-full ">
                  <div className="flex-1 text-left mb-[-20px]">
                    <h3 className="f-f-b-ex text-[25px] sm:text-[30px] text-black relative z-10">
                      up to
                    </h3>
                  </div>
                  <div className="text-left">
                    <h1 className="f-f-b-ex text-[80px] sm:text-[100px] text-black relative z-10">
                      {' '}
                      {/* Added z-10 for layering */}
                      20%
                    </h1>
                  </div>
                </div>
                <img
                  src={Arrowimg} // Ensure this path is correct
                  className="ml-[-10px] transform translate-x-[-50%] -translate-y-[10px] relative z-0" // Use transform to shift the arrow
                  alt="Arrow"
                  style={{ position: 'relative' }} // Optional for more control
                />
              </div>
            </div>

            <div className="col-span-12 lg:col-span-8 z-10">
              <h1 className="f-f-b-ex text-[28px] sm:text-[34px] lg:text-6xl text-black leading-[48px] mt-10 sm:mt-0">
                Additional revenue with our AI-powered energy optimizer
              </h1>

              <Summary paragraph={summaryContent1} />
            </div>
          </div>
        </div>
      </div>
      <div className="additional-bg pb-[64px] sm:pb-0  lg:h-[1000px] ">
        <div className="main-container">
          <div>
            <Heading content="Our offerings" />
            <Summary paragraph={summaryContent2} />
          </div>
          <div className="mt-10 xl:mt-0 xl:py-10">
            <div className="grid grid-cols-12 gap-5 lg:gap-10">
              <div className="col-span-12 sm:col-span-6">
                <div className=" relative text-black hover:text-white bg-class-for-test p-4 sm:p-0 h-auto lg:h-[492px] lg:hover:h-[512px] sm:pt-[21px] sm:pb-[47px]  sm:px-[25px]  rounded-[20px] ">
                  <div className="bg-animated" />
                  <div className="z-10 relative">
                    <img
                      src={Bussinessplan}
                      className="w-full h-auto "
                      alt=""
                    />

                    <h1 className="f-f-b-ex text-[18px] sm:text-xl  mt-2 ">
                      BESS Business Plan Development
                    </h1>
                    <p className="f-f-r text-lg  mt-2 pb-8 sm:pb-0 ">
                      Accurate financial planning with state-of-the-art and
                      data-driven algorithms to ensure successful BESS project
                      development.
                    </p>
                    <div className="col-span-12">
                      <button
                        className="w-[116px] h-[41px] bg-green hover:bg-black-light hover:text-white transition-colors duration-500 rounded-[20px] f-f-sm text-sm text-black-light mt-5 footer-font"
                        onClick={() => navigate('/solution#advisory_services')}
                      >
                        More Info
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 sm:col-span-6">
                <div className=" relative text-black hover:text-white bg-class-for-test p-4 sm:p-0 h-auto lg:h-[492px] lg:hover:h-[512px] sm:pt-[21px] sm:pb-[47px]  sm:px-[25px]  rounded-[20px] ">
                  <div className="bg-animated" />
                  <div className="z-10 relative">
                    <img src={Powerd} className="w-full h-auto" alt="" />

                    <h1 className="f-f-b-ex text-[18px] sm:text-xl  mt-2 ">
                      AI-Powered Optimisation Service
                    </h1>
                    <p className="f-f-r text-lg  mt-2 pb-8 sm:pb-0 ">
                      Advances forecasting and optimization to enhance BESS
                      operations, increasing your profits and extending your
                      system lifespan.
                    </p>
                    <div className="col-span-12">
                      <button
                        className="w-[116px] h-[41px] bg-green hover:bg-black-light hover:text-white transition-colors duration-500 rounded-[20px] f-f-sm text-sm text-black-light mt-5 footer-font"
                        onClick={() =>
                          navigate('/solution#operational_services')
                        }
                      >
                        More Info
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
